import axios from 'axios'
import { useAuthStore } from '../store'
import { API_BASE_URL } from './config'

// Create axios instance
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      useAuthStore.getState().logout()
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// API endpoints
export const endpoints = {
  // Auth
  login: '/auth/login',
  register: '/auth/register',
  profile: '/auth/profile',
  changePassword: '/auth/change-password',
  
  // Services
  services: '/services',
  serviceById: (id: number) => `/services/${id}`,
  servicesByCategory: (category: string) => `/services/category/${category}`,
  mainServices: '/services/main/all',
  subServices: (parentId: number) => `/services/parent/${parentId}/children`,
  
  // Equipment
  equipment: '/equipment',
  equipmentById: (id: number) => `/equipment/${id}`,
  relatedEquipment: (id: number) => `/equipment/${id}/related`,
  equipmentCategories: '/equipment/categories/all',
  featuredEquipment: '/equipment/featured/list',
  
  // Suppliers
  suppliers: '/suppliers',
  supplierById: (id: number) => `/suppliers/${id}`,
  
  // Orders & Inquiries
  inquiries: '/inquiries',
  myInquiries: '/inquiries/my-inquiries',
  inquiryById: (id: number) => `/inquiries/${id}`,
  inquiryPaymentSteps: (id: number) => `/inquiries/${id}/payment-steps`,
  inquiryAttachments: (id: number) => `/inquiries/${id}/attachments`,
  inquiryStatusSteps: '/inquiries/status-steps',
  orders: '/orders',
  myOrders: '/orders/my-orders',
  orderStatusSteps: '/orders/status-steps',
  
  // Announcements
  announcements: '/announcements',
  announcementById: (id: number) => `/announcements/${id}`,
  applyToAnnouncement: (id: number) => `/announcements/${id}/apply`,
  
  // Events
  events: '/events',
  eventById: (id: number) => `/events/${id}`,
  
  // Admin
  adminDashboard: '/admin/dashboard',
  adminCodes: '/admin/codes',
  
  // Utilities
  health: '/health',
  upload: '/uploads/single',
} as const
